import { useLanguage } from "../lang/LanguageContext";
import { parseLinks } from "../utils/parseLinks";
import PublicationBibtex from "./PublicationBibtex";


export default function FeaturedPublications() {
  const { strings } = useLanguage();
  const publications = strings.featuredPublications.list;


  return (
    <section className="mt-16 px-6 max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold mb-6 text-center">{strings.featuredPublications.title}</h2>

      <ul className="space-y-6">
        {publications.map((pub, index) => (
          <li
            key={index}
            className="border rounded-lg p-6 shadow hover:shadow-md transition"
          >
            <div className="flex justify-between items-center mb-1">
              <h3 className="text-lg font-semibold">{pub.title}</h3>
              <PublicationBibtex
                bibtex={pub.bibtex}
                buttton_text={strings.featuredPublications.bib_copy}
              />
            </div>
            <p className="text-sm text-gray-600 mb-2">{pub.authors}. { parseLinks(pub.description, pub.links)}</p>
            <p className="text-sm text-gray-600 mb-3">{pub.date}</p>
            <div className="space-x-4">
              <a
                href={pub.pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 underline"
              >
                PDF
              </a>
              {pub.diapourl && (
                <a
                  href={pub.diapourl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-700 underline"
                >
                  PPTX
                </a>
              )}
              {pub.videoUrl && (<a
                href={pub.videoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 underline"
              >
                Video
              </a>)}
            </div>
          </li>
        ))}
      </ul>
<section className="mt-16 px-6 max-w-4xl mx-auto">
    <h2 className="text-3xl font-bold mb-6 text-center">{strings.preprints.title}</h2>
    <ul className="space-y-6">
        {strings.preprints.list.map((pub, index) => (
          <li
            key={index}
            className="border rounded-lg p-6 shadow hover:shadow-md transition"
          >
            <div className="flex justify-between items-center mb-1">
              <h3 className="text-lg font-semibold">{pub.title}</h3>
              <PublicationBibtex
                bibtex={pub.bibtex}
                buttton_text={strings.preprints.bib_copy}
              />
            </div>
            <p className="text-sm text-gray-600 mb-2">{pub.authors}. { parseLinks(pub.description, pub.links)}</p>
            <p className="text-sm text-gray-600 mb-3">{pub.date}</p>
            <div className="space-x-4">
              <a
                href={pub.pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 underline"
              >
                PDF
              </a>
              {pub.diapourl && (
                <a
                  href={pub.diapourl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-700 underline"
                >
                  PPTX
                </a>
              )}
              {pub.videoUrl && (<a
                href={pub.videoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 underline"
              >
                Video
              </a>)}
            </div>
          </li>
        ))}
      </ul>
    </section>
</section>
  );
  
}
